<div class="content-holder">
  <div class="header align-items-center">
    <p class="title"  *transloco="let t">{{ t('navigation.notifications') }}</p>
    <div class="subtitle" *transloco="let t; scope: 'account'">{{ t('account.notifications_subtitle') }}</div>
  </div>

  <div class="row body">
    <div class="col-12 mt-4">
      @if (error()) {
        <alert [type]="'danger'" [dismissible]="true" class="mb-3">
          <span *transloco="let t">{{ t(error()!) }}</span>
        </alert>
      }

      @if (showSavedFeedback()) {
        <alert [type]="'success'" [dismissOnTimeout]="2500" class="mb-3">
          <span *transloco="let t">{{ t('common.saved') }}</span>
        </alert>
      }

      @if (initialLoading()) {
        <div class="d-flex justify-content-center py-4">
          <multisite-loader-globe-animation-detail [width]="80" [height]="80"></multisite-loader-globe-animation-detail>
        </div>
      } @else {
        <h5 *transloco="let t" class="mb-3">{{t('common.language')}}</h5>  
        <fieldset class="radio-list" [disabled]="isAnythingLoading()">
          @for (language of availableLanguages(); track language.languageKey) {
            <label class="radio-item" [attr.for]="'notification_language_' + language.languageKey">
              <input
                type="radio"
                name="notification_language"
                [id]="'notification_language_' + language.languageKey"
                [checked]="selectedNotificationLanguage() === language.languageKey"
                (change)="onLanguageSelected(language.languageKey)"
              />
              <span class="radio-label" *transloco="let t">{{ t(language.name) }}</span>
            </label>
          }
        </fieldset>

        <ng-container *transloco="let accountT; scope: 'account'">
          <h5 class="mt-4 mb-3">{{ accountT('account.notification_emails.title') }}</h5>
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" role="switch" id="notification_emails"
              [checked]="notificationEmails()" [disabled]="isAnythingLoading()"
              (change)="onNotificationEmailsChanged($any($event.target).checked)" />
            <label class="form-check-label" for="notification_emails">{{ accountT('account.notification_emails.label') }}</label>
          </div>
          <p class="text-muted small mt-2">{{ accountT('account.notification_emails.help') }}</p>

          <ul class="list-unstyled mt-4 mb-0">
            <li><a [routerLink]="['/account/subscriptions']">{{ accountT('account.notification_emails.subscriptions') }} <i class="fa-solid fa-angle-right ml-1"></i></a></li>
            @if (hasIdeas) {
              <li class="mt-2"><a [routerLink]="['/ideas']" [queryParams]="{ following: 'true' }">{{ accountT('account.notification_emails.followed_ideas') }} <i class="fa-solid fa-angle-right ml-1"></i></a></li>
            }
          </ul>
        </ng-container>

        @if (isAnythingLoading()) {
          <div class="d-flex justify-content-center py-3">
            <multisite-loader-globe-animation-detail [width]="64" [height]="64"></multisite-loader-globe-animation-detail>
          </div>
        }
      }
    </div>
  </div>
</div>
